import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  formContainer: {
    marginTop: '8px',
  }
}));
